import { useState, KeyboardEvent, forwardRef } from "react";
import Input from "./Input";
import { FaEyeSlash } from "react-icons/fa";
import { FaEye } from "react-icons/fa";
import styled from "styled-components";
import { COLORS } from "styles/colors";
interface Props {
  value: string;
  isValidated: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onEnter: () => void;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  placeholder?: string;
  maxLength?: number;
  className?: string;
  tabIndex?: number;
  autoFocus?: boolean;
  "data-testid"?: string;
}

const PasswordInput = forwardRef<HTMLInputElement, Props>((props, ref) => {
  const [passwordType, setPasswordType] = useState("password");

  const togglePassword = () => {
    if (passwordType === "password") {
      setPasswordType("text");
    } else {
      setPasswordType("password");
    }
  };
  return (
    <PasswordWrapper>
      <EyeSpan
        onClick={togglePassword}
        data-testid="atoms-input-input-eye-span-toggle-password"
      >
        {passwordType === "password" ? (
          <FaEyeSlash size={18} />
        ) : (
          <FaEye size={18} />
        )}
      </EyeSpan>
      <HiddenInput
        type="search"
        name="username"
        tabIndex={-1}
        data-testid="atoms-input-input-username-change"
      />
      <Input
        ref={ref}
        id="dw_login_input_password"
        type={passwordType}
        name="password"
        data-testid={props["data-testid"]}
        className={props.className}
        placeholder={props.placeholder ? props.placeholder : "Enter Password"}
        value={props.value}
        onChange={props.onChange}
        autoComplete="new-password"
        onKeyDown={(e: KeyboardEvent<HTMLInputElement>) => {
          if (e.key === "Enter") {
            props.onEnter();
          }
        }}
        maxLength={props.maxLength}
        autoFocus={props.autoFocus}
        isValidated={props.isValidated}
        onFocus={props.onFocus}
        onBlur={props.onBlur}
        tabIndex={props.tabIndex}
      />
    </PasswordWrapper>
  );
});

const HiddenInput = styled.input`
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  opacity: 0;
  z-index: -1;
`;

const PasswordWrapper = styled.div`
  width: 100%;
  position: relative;
`;
const EyeSpan = styled.span`
  display: flex;
  align-items: center;
  position: absolute;
  height: 100%;
  top: 0;
  right: 0;
  padding-right: 10px;
  color: ${COLORS.BLACK};
`;

export default PasswordInput;
